export * from './create-points.page'
export * from './create-points.reducer'